import { settings } from '../utilsData';

const Picture = ({
  className,
  path,
  image,
  format,
  width,
  height,
  altText,
}) => {
  return (
    <picture className={className}>
      <source
        type={'image/webp'}
        srcSet={
          '../' +
          path +
          '/' +
          image +
          '.webp' +
          ', ' +
          '../' +
          path +
          '/' +
          image +
          '@2x.webp' +
          ' 2x'
        }
      />
      <img
        src={'../' + path + '/' + image + '.' + format}
        srcSet={'../' + path + '/' + image + '@2x.' + format + ' 2x'}
        width={width}
        height={height}
        alt={altText}
      />
    </picture>
  );
};

function debounce(func, wait = 100) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

const getAllowedParentOrigins = () => {
  if (import.meta.env.MODE === 'stage') {
    return [settings.VITE_STAGE_URL];
  }
  if (import.meta.env.MODE === 'master') {
    return [
      settings.VITE_MASTER_URL,
      settings.VITE_MASTER_MIRROR2_URL,
      settings.VITE_MASTER_MIRROR_URL,
      settings.VITE_TEST_MASTER_URL,
    ];
  }
  return ['http://wizard.local'];
};

const resolveTrustedParentOrigin = () => {
  const allowed = getAllowedParentOrigins();
  const candidates = [];

  try {
    if (window.location.ancestorOrigins?.length) {
      candidates.push(window.location.ancestorOrigins[0]);
    }
  } catch (_error) {
    /* ancestorOrigins is not available in all browsers */
  }

  try {
    if (document.referrer) {
      candidates.push(new URL(document.referrer).origin);
    }
  } catch (_error) {
    /* ignore invalid referrer */
  }

  for (const candidate of candidates) {
    if (allowed.includes(candidate)) {
      return candidate;
    }
  }

  return allowed[0];
};

const SEND_DATA_TO_PARENT_WINDOW = (data) => {
  window.parent.postMessage(data, resolveTrustedParentOrigin());
};

const navigateParentTo = (suffix = '') => {
  if (self === top) {
    window.parent.location = document.URL + suffix;
    return;
  }

  const trustedOrigin = resolveTrustedParentOrigin();
  let base = `${trustedOrigin}/`;

  try {
    if (document.referrer) {
      const referrerUrl = new URL(document.referrer);
      if (referrerUrl.origin === trustedOrigin) {
        base = document.referrer;
      }
    }
  } catch (_error) {
    /* fall back to allowlisted origin */
  }

  window.parent.location = base + suffix;
};

const removeSpaces = (string) => string.toString().replace(/ /g, '');

const splitNumberIntoDigits = (number) =>
  number
    .toString()
    .replace(/ /g, '')
    .replace(/\D/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

function isEmpty(obj) {
  for (let key in obj) {
    // если тело цикла начнет выполняться - значит в объекте есть свойства
    return false;
  }
  return true;
}

const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

const getCookie = (name) => {
  let matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

const checkTokenExpiresDate = (date) => {
  const today = new Date().getTime();
  if (today > date) {
    return false;
  }
  return true;
};

const checkOrigin = (origin) => getAllowedParentOrigins().includes(origin);

export {
  Picture,
  debounce,
  isEmpty,
  splitNumberIntoDigits,
  removeSpaces,
  SEND_DATA_TO_PARENT_WINDOW,
  navigateParentTo,
  setCookie,
  getCookie,
  checkTokenExpiresDate,
  checkOrigin,
};
